"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecipientList = void 0;
var react_1 = __importDefault(require("react"));
require("./RecipientList.scss");
require("@app/features/package-details/components/PackageRecipient.scss");
var Avatar_1 = require("@app/components/users/Avatar");
var StatusAvatar_1 = require("@app/components/users/StatusAvatar");
var utils_1 = require("@app/shared/utils");
var constants_1 = require("@server/shared/constants");
var RecipientList = function (props) {
    var visibleUsers = props.recipients.slice(0, props.maxVisibleRecipients);
    var overflowUsers = props.recipients.slice(props.maxVisibleRecipients);
    return (react_1.default.createElement("div", { className: "recipient-list" },
        visibleUsers.map(function (r) {
            return react_1.default.createElement(StatusAvatar_1.StatusAvatar, { key: r.userEmail, user: r, className: 'tooltip', showCheckmark: props.downloaders.findIndex(function (d) { return d === r.userEmail; }) > -1 });
        }),
        overflowUsers.length > 0 &&
            react_1.default.createElement("div", { className: "dropdown is-right is-hoverable" },
                react_1.default.createElement("div", { className: "dropdown-trigger" },
                    react_1.default.createElement(Avatar_1.Avatar, { text: "+" + overflowUsers.length })),
                react_1.default.createElement("div", { className: "dropdown-menu is-", role: "menu" },
                    react_1.default.createElement("div", { className: "dropdown-content" }, overflowUsers.map(function (u) { return (react_1.default.createElement("div", { className: "dropdown-item", key: u.userEmail },
                        react_1.default.createElement("div", { className: "recipient" },
                            react_1.default.createElement(StatusAvatar_1.StatusAvatar, { user: u, showCheckmark: props.downloaders.findIndex(function (d) { return d === u.userEmail; }) > -1 }),
                            react_1.default.createElement("div", { className: "recipient-info" },
                                react_1.default.createElement("div", { className: "recipient-name" },
                                    react_1.default.createElement("span", null, utils_1.getUserTitle(u))),
                                react_1.default.createElement("div", { className: "recipient-email" },
                                    react_1.default.createElement("span", null, u.lastName !== constants_1.EXTERNAL_EMAIL ? u.userEmail : '')))))); }))))));
};
exports.RecipientList = RecipientList;
